import {useEffect} from "react";

export function useOnClickOutside(document, domRef, onClickOutside) {
    useEffect(() => {
        const handleOnClickOutside = (e) => {
            if (domRef && domRef.current && !domRef.current.contains(e.target)) {
                console.log(domRef.current);
                onClickOutside && onClickOutside();
            }
        }
        document.addEventListener('click', handleOnClickOutside, true);
        return () => {
            document.removeEventListener('click', handleOnClickOutside, true);
        };
    }, [onClickOutside]);
}